import state from './state'
import mutations from './mutations'
import actions from './actions'

const motivosMatriculaPerdida = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default motivosMatriculaPerdida
